import React, { useEffect, useRef } from "react";
import ApexCharts from "apexcharts";
import { convertSecondsToHours } from "../../../../common/util";

const MachineColumnChart = ({ chartdata, chartKey }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  const defaultSeries = [
    { name: "DURATION", data: new Array(8).fill(0) },
    { name: "TARGET", data: new Array(8).fill(0) },
  ];

  const defaultCategories = [];

  // Validate seriesData to ensure it contains numbers
  const isValidSeries = (series) =>
    Array.isArray(series) &&
    series.every((item) => item?.name && Array.isArray(item.data) && item.data.every((num) => !isNaN(num) && num !== null));

  const seriesData = isValidSeries(chartdata?.chartData) ? chartdata.chartData : defaultSeries;
  const categoriesData = Array.isArray(chartdata?.sortedMachineCode) && chartdata.sortedMachineCode.length
    ? chartdata.sortedMachineCode
    : defaultCategories;

  const statusData = [
    { key: "OK", message: "OK", color: "#0BDA51" },
    { key: "REJECT", message: "REJECT", color: "#E23D28" },
    { key: "REWORK", message: "REWORK", color: "#FF8C00" },
    { key: "DURATION", message: "DURATION", color: "#007BFF" },
    { key: "TARGET", message: "TARGET", color: "#0BDA51" },
  ];

  const colors = seriesData.map((series) =>
    statusData.find((status) => status.message === series.name)?.color || "#808080"
  );

  useEffect(() => {
    if (!chartRef.current) return;

    // Destroy previous chart instance if it exists
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    chartInstance.current = new ApexCharts(chartRef.current, {
      series: seriesData,
      chart: {
        type: "bar",
        height: 350,
        width: "100%", // Ensuring width is always set
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "90%",
          borderRadius: 10,
          borderRadiusApplication: "end",
          dataLabels: {
            position: "top", // top, center, bottom
          },
        },
      },
      colors,
      dataLabels: {
        enabled: true,
        formatter: (val) => (!isNaN(val) ? convertSecondsToHours(val) : 0), // Prevent NaN values
        offsetY: -20,
        style: { fontSize: "12px", colors: ["#304758"] },
      },
      stroke: { show: true, width: 2, colors: ["transparent"] },
      xaxis: {
        categories: categoriesData,
        labels: {
          rotate: -30,
          style: { fontSize: "10px", colors: "#000" },
        },
      },
      fill: { opacity: 1 },
      tooltip: { y: { formatter: (val) => `${convertSecondsToHours(val) ?? 0}` } }, // Prevent NaN in tooltip
    });

    chartInstance.current.render();

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seriesData, categoriesData]);

  return <div id={`columnChart-${chartKey}`} ref={chartRef} style={{ width: "100%", minHeight: "350px" }}></div>;
};

export default MachineColumnChart;
